import { Dashboardv20240730CommonModels } from '@sequencehq/api/dashboard/v20240730'
import { isAfter } from '@sequencehq/utils/dates'
import { getBillingDates } from '@sequencehq/utils'
import { ResolvedPhase } from 'modules/Cube/domain/cube.domain.types'

type BillingFrequency =
  Dashboardv20240730CommonModels.PricingStructure.BillingFrequency

const FREQUENCY_MONTH_MAPPINGS: Record<BillingFrequency, number> = {
  ONE_TIME: 0,
  ON_DEMAND: 0,
  PER_EVENT: 0,
  MONTHLY: 1,
  QUARTERLY: 3,
  HALF_YEARLY: 6,
  YEARLY: 12
}

export const getNextBillingDateAfterEndDate = ({
  recurrenceDayOfMonth,
  phaseDates,
  prices
}: {
  recurrenceDayOfMonth?: number
  phaseDates: ResolvedPhase['dates']
  prices: ResolvedPhase['prices']
}) => {
  /**
   * Ongoing phases never end, so they are always valid. This is also the
   * case when we have no pricing data for the phase.
   */
  if (
    phaseDates.duration === 'OPEN_ENDED' ||
    !phaseDates.duration ||
    !prices.length ||
    !phaseDates.absolute.end ||
    !phaseDates.absolute.start ||
    !recurrenceDayOfMonth
  ) {
    return null
  }

  const viableEndDates = getBillingDates({
    recurrenceDayOfMonth,
    phaseDates: {
      start: phaseDates.absolute.start,
      end: phaseDates.absolute.end
    }
  })

  const minimumPhaseBillingFrequency = prices.reduce(
    (acc: BillingFrequency, price) => {
      if (
        FREQUENCY_MONTH_MAPPINGS[price.billingFrequency] >
        FREQUENCY_MONTH_MAPPINGS[acc]
      ) {
        return price.billingFrequency
      }

      return acc
    },
    'ONE_TIME'
  )

  const nextBillingDateAfterEndDate = phaseDates.absolute.end
    ? (viableEndDates[minimumPhaseBillingFrequency].find(date =>
        isAfter(date, phaseDates.absolute.end as Date)
      ) ?? null)
    : null

  return nextBillingDateAfterEndDate
}
